module.exports = __webpack_public_path__ + "static/media/universe_orange.43faa9b4.png";